export const media = {
  xs: '@media (max-width: 480px)',
  sm: '@media (max-width: 786px)',
  md: '@media (max-width: 992px)',
  lg: '@media (min-width: 993px)',
};
